import { defineBasicExtension } from "prosekit/basic";
import { Extension, union } from "prosekit/core";
import { defineTextColor } from "./extensions/text-color";
import { defineHighlight } from "./extensions/highlight";
import { definePasteConversion } from "./extensions/paste-conversion";
import { defineMarkdownLinkInputRule } from "./extensions/markdown-link";
import { defineMention } from "prosekit/extensions/mention";
import { defineReadonly } from "prosekit/extensions/readonly";
import { definePlaceholder } from "prosekit/extensions/placeholder";

type Args = {
  readOnly?: boolean;
  placeholder?: string;
};

export function defineExtension({ readOnly, placeholder }: Args) {
  const optionalExtensions: Extension[] = [];
  if (readOnly) optionalExtensions.push(defineReadonly());
  if (placeholder)
    optionalExtensions.push(
      definePlaceholder({ placeholder, strategy: "doc" }),
    );

  return union(
    defineBasicExtension(),
    defineTextColor(),
    defineHighlight(),
    defineMention(),
    definePasteConversion(),
    defineMarkdownLinkInputRule(),
    ...optionalExtensions,
  );
}

export type EditorExtension = ReturnType<typeof defineExtension>;
